import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { urlEdizione } from './links';

/**
 * Conserva il vecchio indirizzo /tornei/statistiche/:idEdizione, che è quello stampato sui QR
 * code già distribuiti e su cui punta la scorciatoia /qr/verifica: quei codici non si possono
 * ristampare, quindi la rotta non si può togliere.
 */
export default function RedirectEdizione() {
  const { idEdizione } = useParams();
  return <Navigate to={urlEdizione(idEdizione)} replace />;
}
